import { combineReducers } from "redux";

import appReducer from "./app";
import quizReducer from "./quiz";
import quizResultReducer from "./quizResult";
import backgroundReducer from "./background";

const rootReducer = combineReducers({
  app: appReducer,
  quiz: quizReducer,
  quizResult: quizResultReducer,
  background: backgroundReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js